import { ServiceComboDefinition } from "@/Common/Api/Services/Dto/Responses/ServiceDefinition";
import { Guid } from "@/Common/Models/Guid";
import { ServiceComboTargetClientele } from "@/Common/Models/Services/Enums/ServiceComboTargetClientele";
import { BaseServiceComboDefinitionModel } from "./BaseServiceDefinitionModel";
import { IServicePublishingConfig } from "./IServicePublishingConfig";
import { ServiceDefinitionModel } from "./ServiceDefinitionModel";

class ServiceComboDefinitionModel extends BaseServiceComboDefinitionModel {
    public Model: ServiceComboDefinition;
    public Name: string;
    public ServiceDefinitions: ServiceDefinitionModel[];

    public PrimaryServiceDefinitionId: Guid;

    constructor(combo: ServiceComboDefinition) {
        super();

        if (combo == null) {
            this.Model = new ServiceComboDefinition();
            this.Model.OnlineClienenteleCible = ServiceComboTargetClientele.Open;
            this.Model.SiteId = sessionStore.getCurrentEmployee().getActiveSite().Model.Id;
        }
        else {
            this.Model = combo;
            this.Model.ComboId = combo.ComboId;
            this.Model.Name = cacheStore.GetLocalizedValueByLookupId(combo.NameLookupId);
            this.OnlineGroupId = combo.OnlineGroupId;
            this.OnlineNameLookupId = combo.OnlineNameLookupId;
            this.OnlineDescriptionLookupId = combo.OnlineDescriptionLookupId;
            this.OnlineDisclaimerLookupId = combo.OnlineDisclaimerLookupId;
            this.Model.SiteId = combo.SiteId;
            this.Model.SpecializationLookupId = combo.SpecializationLookupId;
            this.Model.IsServiceUrgent = combo.IsServiceUrgent;
            this.Model.OnlineClienenteleCible = combo.OnlineClienenteleCible;
            this.Model.PublishingRule = combo.PublishingRule;
            this.Model.PublishingTimeframe = combo.PublishingTimeframe;
            this.Model.IsAvailableOnline = combo.IsAvailableOnline;
            this.Model.Price = combo.Price;
            this.Model.IsPriceIncludingTaxes = combo.IsPriceIncludingTaxes;
            this.PrimaryServiceDefinitionId = combo.PrimaryServiceDefinitionId;
            this.NotificationConfigurationId = combo.NotificationConfigurationId;
        }

        this.InitLookup();
        this.ServiceDefinitions = [];
    }

    public AddServiceDefinition(ServiceDefinitionId: Guid, IsPrimary: boolean): void {
        if (IsPrimary === true)
            this.PrimaryServiceDefinitionId = ServiceDefinitionId;

        let comboService = cacheStore.GetServiceDefinitionById(ServiceDefinitionId);

        this.ServiceDefinitions.push(comboService);
    }

    public GetDefaultDurationMinutes(): number {
        var dureeMin = 0;

        this.ServiceDefinitions.forEach(x => {
            dureeMin += x.GetDefaultDurationMinutes();
        });

        return dureeMin;
    }

    public Clone(deepClone: boolean = true): ServiceComboDefinitionModel {
        var fullCloneWithMethods = new ServiceComboDefinition();
        $.extend(fullCloneWithMethods, JSON.parse(JSON.stringify(this.Model)));
        var clonedService = new ServiceComboDefinitionModel(fullCloneWithMethods);
        clonedService.PrimaryServiceDefinitionId = this.PrimaryServiceDefinitionId;

        if (deepClone == true) {
            var serviceDefsClones: ServiceDefinitionModel[] = [];
            this.ServiceDefinitions.forEach(x => {
                serviceDefsClones.push(x.Clone(true));
            });

            clonedService.ServiceDefinitions = serviceDefsClones;
        }

        return clonedService;
    }

    public InitLookup(): void {
        if (this.Model.NameLookupId == null)
            return;

        var Namelookup = cacheStore.GetLookupById(this.Model.NameLookupId);
        if (Namelookup != null) {
            this.NameFR = Namelookup.fr;
            this.NameEN = Namelookup.en;
            this.NameES = Namelookup.esMX;
            this.Name = Namelookup.GetValue();
        }
        else {
            this.NameFR = "Wait for next cache Refresh";
            this.NameEN = "Wait for next cache Refresh";
            this.NameES = "Wait for next cache Refresh";
            this.Name = "Wait for next cache Refresh";
        }
    }

    public GetIsNotifyPatientDisabledByDefault(): boolean {
        if (this.Model)
            return this.Model.IsNotifyPatientDisabledByDefault;

        return false;
    }

    public SetIsNotifyPatientDisabledByDefault(val: boolean): void {
        if (this.Model)
            this.Model.IsNotifyPatientDisabledByDefault = val;
    }

    public GetUrgency(): boolean {
        if (this.Model)
            return this.Model.IsServiceUrgent;

        return false;
    }

    public SetUrgency(val: boolean): void {
        if (this.Model)
            this.Model.IsServiceUrgent = val;
    }

    public SetOnlineAvailability(val: boolean): void {
        if (this.Model)
            this.Model.IsAvailableOnline = val;
    }

    public GetOnlineAvailability(): boolean {
        if (this.Model)
            return this.Model.IsAvailableOnline;

        return false;
    }

    public SetOnlineClienenteleCible(val: number): void {
        if (this.Model)
            this.Model.OnlineClienenteleCible = val;
    }

    public GetOnlineClienenteleCible(): number {
        if (this.Model)
            return this.Model.OnlineClienenteleCible;

        return 0;
    }

    public ToggleIsPriceIncludingTaxes(): void {
        if (this.Model != null)
            this.Model.IsPriceIncludingTaxes = !this.Model.IsPriceIncludingTaxes;
    }

    public SetPublishingConfig(val: IServicePublishingConfig): void {
        if (this.Model) {
            this.Model.PublishingRule = val.rule;
            this.Model.PublishingTimeframe = val.timeframe;
        }
    }

    public GetPublishingConfig(): IServicePublishingConfig | null {
        if (this.Model) {
            return {
                rule: this.Model.PublishingRule,
                timeframe: this.Model.PublishingTimeframe
            };
        }

        return null;
    }

    public SetSiteId(val: Guid): void {
        if (this.Model)
            this.Model.SiteId = val;
    }

    public GetSiteId(): Guid {
        if (this.Model)
            return this.Model.SiteId;

        return null;
    }

    public SetSpecializationId(val: string): void {
        if (this.Model)
            this.Model.SpecializationLookupId = val;
    }

    public GetSpecializationId(): string {
        if (this.Model)
            return this.Model.SpecializationLookupId;

        return "";
    }

    public SetPrice(val: number): void {
        if (!isNaN(Number(val)) && this.Model)
            this.Model.Price = val;
        else
            throw new TypeError("Invalid Number " + val);
    }

    public GetPrice(): number {
        if (this.Model)
            return this.Model.Price > 0 ? this.Model.Price : 0;

        return 0;
    }

    public SetIsTeleconsultation(val: boolean): void {
        if (this.Model) {
            this.Model.IsTeleconsultation = val;

            if (val)
                this.Model.IsNotifyPatientDisabledByDefault = !val;
        }
    }

    public GetIsTeleconsultation(): boolean {
        if (this.Model)
            return this.Model.IsTeleconsultation;

        return false;
    }

    public SetQuestionnaireId(val: string): void {
        if (this.Model)
            this.Model.QuestionnaireId = val;
    }

    public GetQuestionnaireId(): string {
        if (this.Model)
            return this.Model.QuestionnaireId;
    }
}

export { ServiceComboDefinitionModel };
